import { CustomLabel } from "@mindmemobile/mm-shared-global";
import React from "react";

interface ItemNotAvailableWarningProps {
  margin?: string;
}

const ItemNotAvailableWarning: React.FC<ItemNotAvailableWarningProps> = ({ margin }) => {
  return (
    <CustomLabel color="#f00" margin={margin} className="error-warning">
      This item is currently unavailable
    </CustomLabel>
  );
};

export default ItemNotAvailableWarning;
